import Vue from 'vue'
import Router from 'vue-router'
import tasks from '@/view/tasks'
import dirverMap from '@/view/dirverMap'
import addressBook from '@/view/addressBook'
import broadcast from '@/view/broadcast'
import login from "@/view/login";
import index from '@/App'
import organization from "@/view/organization";
import drivers from "@/view/drivers";
import list_test from "../view/test/list_test";
import FailureReview from "../view/FailureReview"
import WageReview from "../view/WageReview"
import billing from "../view/billing"
// import dispatch from "@/view/dispatch/dispatch";
import dispatch_test from "@/view/dispatch_test/index/dispatch_test";
import analyze from "@/view/analyze"
import preTask from '@/view/preTask'
import layout from "@/view/layout";
import assigRule from "@/view/assigRules"
import administrator from "@/view/administrator";
import pay_test from "@/view/pay_test";
import toolBox from '@/view/toolBox/index'//用来内部检测的页面



Vue.use(Router)
const originalPush = Router.prototype.push
const originalReplace = Router.prototype.replace

Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject)
  }
  return originalPush.call(this, location).catch(err => err)
}


Router.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject)
  }
  return originalReplace.call(this, location).catch(err => err)
}

export default new Router({
  routes: [
    {
      path: "/",
      redirect: "/tasks",
      hidden: true,
    },
    {
      path: "/login",
      component: login,
      name: "login",
      hidden: true,
    },
    {
      path: "",
      component: layout,
      children: [
        {
          path: '/',
          redirect:'/tasks',
          name: '',
          component: index,
        },
        {
          path:'/tasks',
          name:'tasks',
          component:tasks,
          meta:{
            title:'Tasks'
          }
        },
        {
          path: '/list_test',
          component: list_test,
          meta:{
            title:'list_test'
          }
        },
        {
          path: '/FailureReview',
          component: FailureReview,
          meta:{
            title:'FailureReview'
          }
        },
        {
          path: '/WageReview',
          component: WageReview,
          meta:{
            title:'Earnings review'
          }
        },

        {
          path:'/preTask',
          name:'preTask',
          component:preTask,
          meta:{
            title:'Pre-task Pool'
          }
        },
        {
          path:'/dirverMap',
          name:'dirverMap',
          component:dirverMap,
          meta:{
            title:'Driver map'
          }
        },
        {
          path:'/addressBook',
          name:'addressBook',
          component:addressBook,
          meta:{
            title:'Address Book'
          }
        },
        {
          path:'/broadcast',
          name:'broadcast',
          component:broadcast,
          meta:{
            title:'Broadcast'
          }
        },

        {
          path:'/organizations',
          name:'organizations',
          component:organization,
          meta:{
            title:'Organizations'
          }
        },

        {
          path:'/driver',
          name:'driver',
          component:drivers,
          meta:{
            title:'drivers'
          }
        },

        // {
        //   path:'/assigRules',
        //   name:'assigRule',
        //   component:assigRule,
        //   meta:{
        //     title:'Rules'
        //   }
        // },
        // {
        //   path:'/dispatch',
        //   name:'dispatch',
        //   component:dispatch,
        //   meta:{
        //     title:'dispatch'
        //   }
        // },
        {
          path:'/Dispatch',
          name:'Dispatch',
          component:dispatch_test,
          meta:{
            title:'dispatch'
          }
        },
        // analyze

        {
          path:'/analyze',
          name:'analyze',
          component:analyze,
          meta:{
            title:'Analytics'
          }
        },
        // {
        //   path:'/login',
        //   name:'login',
        //   component:login,
        //   meta:{
        //     title:''
        //   }
        // },

        {
          path:'/Administrator',
          name:'Administrator',
          component:administrator,
          meta:{
            title:'Administrator'
          }
        },
        // {
        //   path:'/Billing',
        //   name:'Billing',
        //   component:billing,
        //   meta:{
        //     title:'Billing'
        //   }
        // },
        {
          path:'/pay_test',
          name:'pay_test',
          component:pay_test,
          meta:{
            title:'pay_test'
          }
        },
        {
          path:'/toolBox',
          name:'toolBox',
          component:toolBox,
          meta:{
            title: 'toolBox'
          }
        },

      ],
    },
    ],
})


